/** * 系统操作日志 */
<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<logList v-if="activeTab === '1'" ref="logList"></logList>
			<exportLog v-if="activeTab === '2'" ref="exportLog"></exportLog>
			<logList v-if="activeTab === '3'" key="screen-lock" fixed-module="系统锁屏"></logList>
		</topTab>
	</div>
</template>

<script>
import logList from "./logList.vue";
import exportLog from "./exportLog.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "日志记录"
				},
				{
					key: "2",
					value: "导出日志"
				},
				{
					key: "3",
					value: "锁屏记录"
				}
			]
		};
	},
	// 注册组件
	components: {
		logList,
		exportLog
	},
	/**
	 * 创建完毕
	 */
	created() {},
	computed: {},
	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		changePages(tab) {
			this.activeTab = tab;
		}
	}
};
</script>

<style scoped></style>
